"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogClient = exports.getSessionId = exports.setSessionId = void 0;
exports.logExposure = logExposure;
exports.logEvent = logEvent;
exports.logConvertExperiment = logConvertExperiment;
exports.logConvertExperimentWithOverrides = logConvertExperimentWithOverrides;
exports.logStartExperiment = logStartExperiment;
exports.logStartExperimentWithOverrides = logStartExperimentWithOverrides;
exports.sendMetrics = sendMetrics;
exports.logMonsterverseEvents = logMonsterverseEvents;
exports.logMonsterversePerfStats = logMonsterversePerfStats;
exports.logMonsterverseMessage = logMonsterverseMessage;
exports.logException = logException;
exports.logMessage = logMessage;
exports.logDuration = logDuration;
exports.logRequestError = logRequestError;
exports.init = init;
exports.setSend = setSend;
exports.setEntityId = setEntityId;
exports.setFeatureSetId = setFeatureSetId;
exports.setSite = setSite;
exports.setCustomEndpoint = setCustomEndpoint;
exports.getEntityId = getEntityId;
exports.getFeatureSetId = getFeatureSetId;
exports.getSite = getSite;
exports.setMetadata = setMetadata;
exports.getMetadata = getMetadata;
exports.getFeatureSwitches = getFeatureSwitches;
exports.clearMetadata = clearMetadata;
exports.setOnEvent = setOnEvent;
exports.setProductArea = setProductArea;
exports.setRoute = setRoute;
exports.setPath = setPath;
exports.setEntityType = setEntityType;
exports.getEntityType = getEntityType;
exports.setFeatureSwitches = setFeatureSwitches;
exports.setNetworkIsActive = setNetworkIsActive;
exports.setEventLoggingPaused = setEventLoggingPaused;
exports.setIsWifi = setIsWifi;
exports.setOsVersion = setOsVersion;
exports.flush = flush;
require("console-polyfill");
var logging_1 = require("./logging");
var client_1 = require("./client");
Object.defineProperty(exports, "LogClient", { enumerable: true, get: function () { return client_1.LogClient; } });
var sessionId_1 = require("./sessionId");
Object.defineProperty(exports, "setSessionId", { enumerable: true, get: function () { return sessionId_1.set; } });
Object.defineProperty(exports, "getSessionId", { enumerable: true, get: function () { return sessionId_1.get; } });
var currentInstance;
function logExposure(data) {
    try {
        return currentInstance.logExposure(data);
    }
    catch (e) {
        handleError(e);
    }
}
function logEvent(rawData) {
    try {
        return currentInstance.logProductEvent(rawData);
    }
    catch (e) {
        handleError(e);
    }
}
function logConvertExperiment(experiment) {
    try {
        return currentInstance.logConvertExperiment(experiment);
    }
    catch (e) {
        handleError(e);
    }
}
function logConvertExperimentWithOverrides(experiment, variant, entityId, entityType) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logConvertExperimentWithOverrides(experiment, variant, entityId, entityType)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_1 = _a.sent();
                    handleError(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function logStartExperiment(experiment) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logStartExperiment(experiment)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_2 = _a.sent();
                    handleError(e_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * Most of the time, you probably want `logStartExperiment` instead!
 * This is mostly for monsterverse where they want to be able to log `class` and `school` experiments
 * @param experiment
 * @param variant
 * @param entityId can be a classId or schoolId
 * @param entityType
 */
function logStartExperimentWithOverrides(experiment, variant, entityId, entityType) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logStartExperimentWithOverrides(experiment, variant, entityId, entityType)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_3 = _a.sent();
                    handleError(e_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function sendMetrics(metrics) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logMetrics(metrics)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_4 = _a.sent();
                    handleError(e_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function logMonsterverseEvents(events) {
    try {
        currentInstance.logMonsterverseProductEvents(events);
    }
    catch (e) {
        handleError(e);
    }
}
function logMonsterversePerfStats(stats) {
    try {
        currentInstance.logMonsterversePerfStats(stats);
    }
    catch (e) {
        handleError(e);
    }
}
function logMonsterverseMessage(log) {
    try {
        currentInstance.logMonsterverseMessage(log);
    }
    catch (e) {
        handleError(e);
    }
}
function logException(error, info) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logException(error, info)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_5 = _a.sent();
                    handleError(e_5);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function logMessage(logType, message, context) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logMessage(logType, message, context)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_6 = _a.sent();
                    handleError(e_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function logDuration(data) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logDuration(data)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_7 = _a.sent();
                    handleError(e_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function logRequestError(type, request, response, info) {
    return __awaiter(this, void 0, void 0, function () {
        var results, e_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, currentInstance.logRequestError(type, request, response, info)];
                case 1:
                    results = _a.sent();
                    return [2 /*return*/, results];
                case 2:
                    e_8 = _a.sent();
                    handleError(e_8);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function init(options) {
    var env = options.env;
    if (!env) {
        throw new Error("must provide env");
    }
    if (/prod/.test(env) || /usp/.test(env)) {
        env = "prod";
    }
    var validEnvs = ["testing", "prod", "dev", "testing-logclient", "dev-logclient"];
    if (validEnvs.indexOf(env) === -1) {
        throw new Error(env + " isn't one of " + validEnvs.join(", "));
    }
    options.env = env;
    if (options.initNewInstance) {
        return new client_1.LogClient(options);
    }
    currentInstance = new client_1.LogClient(options);
    return currentInstance;
}
function setSend(sender) {
    currentInstance.sender = sender;
}
function setEntityId(id) {
    currentInstance.entityId = id;
}
function setFeatureSetId(id) {
    currentInstance.featureSetId = id;
    currentInstance.setMetadata("featureSetId", id);
}
function setSite(site) {
    currentInstance.site = site;
}
function setCustomEndpoint(e) {
    currentInstance.customEndpoint = e;
}
function getEntityId() {
    return currentInstance.entityId;
}
function getFeatureSetId() {
    return currentInstance.featureSetId;
}
function getSite() {
    return currentInstance.site;
}
function setMetadata(key, value) {
    currentInstance.setMetadata(key, value);
}
function getMetadata() {
    return currentInstance.metadata;
}
function getFeatureSwitches() {
    return currentInstance.featureSwitches;
}
function clearMetadata(key) {
    if (key) {
        delete currentInstance.metadata[key];
    }
    else {
        currentInstance.clearMetadata();
    }
}
function setOnEvent(f) {
    currentInstance.onEvent = f;
}
function setProductArea(productArea) {
    currentInstance.productArea = productArea;
}
function setRoute(route) {
    currentInstance.route = route;
}
function setPath(path) {
    currentInstance.path = path;
}
function setEntityType(entityType) {
    currentInstance.entityType = entityType;
}
function getEntityType() {
    return currentInstance.entityType;
}
function setFeatureSwitches(featureSwitches) {
    currentInstance.featureSwitches = featureSwitches;
}
/** @deprecated Testing of this feature in live codebases demonstrated a meaningful
 * dropoff in total event arrivals. We've renamed the behavior to accurately reflect
 * the underlying behavior as it might be useful. If you want to use this feature to
 * batch log events and send them while the network is already active, make sure you
 * verify that delivery isn't being impacted.
 **/
function setNetworkIsActive(isActive) {
    currentInstance.setEventLoggingPaused(!isActive);
}
function setEventLoggingPaused(isPaused) {
    currentInstance.setEventLoggingPaused(isPaused);
}
function setIsWifi(isWifi) {
    currentInstance.setIsWifi(isWifi);
}
function setOsVersion(osVersion) {
    currentInstance.setOsVersion(osVersion);
}
function flush() {
    currentInstance.flush();
}
function handleError(err) {
    var typedErr = (typeof err === "string" ? new Error(err) : err);
    (0, logging_1.warn)(typedErr.message);
    var env = currentInstance.env;
    if (env === "testing" || env === "dev" || env === "testing-logclient") {
        throw typedErr;
    }
}
//# sourceMappingURL=index.js.map